'use strict'

import React, { useEffect, useState } from 'react'
import ProductCard from './productCard/ProductCard'
import { analytics, eventEmitter } from '../../../common/baseData'
import { useInView } from 'react-intersection-observer'

function ProductList (props) {
  const { ref, inView } = useInView({
    threshold: 0,
    triggerOnce: true
  })
  const [productIds, setProductIds] = useState([])

  useEffect(() => {
    eventEmitter.emit('handleWishlistItems', {
      node: document.querySelectorAll('.search-page.catalog-list [data-container="favorite"][data-use="add"]'),
      range: 'search'
    })

    eventEmitter.emit('handleCompareItems', {
      node: document.querySelectorAll('.search-page.catalog-list [data-container="compare"][data-use="add"]'),
      range: 'search'
    })
  },[])

  useEffect(() => {
    let product_ids = []

    if (props.products.length) {
      props.products.forEach(item => {
        if (item.hasOwnProperty('ID') && Number(item.ID))
          product_ids.push(Number(item.ID))
      })
    }

    setProductIds(product_ids)
  }, [props.products])

  // GA4 / sending item list view event
  useEffect(() => {
    if (!inView || !props.products.length) return

    analytics.viewItemList(productIds, 'Search Products', 'search_products')
      .then(response => {
        analytics.view_item_list(response.events[0].params);
        console.info(response)
      })
      .catch(reason => (console.error(reason)))
  }, [inView])

  function onClick (productData) {
    let product_id = Number(productData.ID)

    analytics.selectItem(product_id, 'Search Products', 'search_products')
      .then(response => {
        console.info(response, product_id)
        try {
          analytics.select_item(response.data.params);
          let ms_product_id = productData['PROPERTIES']['CML2_BAR_CODE']['VALUE']
          eventEmitter.emit('MSAddClickHistory', { productId: ms_product_id })
        } catch (reason) {
          console.log(reason)
        }
        window.location.href = productData['DETAIL_PAGE_URL']
      })
      .catch(reason => {
        console.error(reason)
        try {
          let ms_product_id = productData['PROPERTIES']['CML2_BAR_CODE']['VALUE']
          eventEmitter.emit('MSAddClickHistory', { productId: ms_product_id })
        } catch (reason) {
          console.log(reason)
        }
        window.location.href = productData['DETAIL_PAGE_URL']
      })
  }

  return (
    <>
      {
        props.products.length ?
          <div className={'catalog-list without-top search-page'} ref={ref}>
            {
              props.products.map(product => {
                return <ProductCard {...product} key={product.XML_ID}
                                    getMessage={props.getMessage} onClick={onClick}/>
              })
            }
          </div> :
          <></>
      }
    </>
  )
}

export default ProductList